import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-path": "url(#a)",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M3.267 4.618A2.05 2.05 0 0 1 4.733 4h6.534c.552 0 1.08.224 1.466.618s.6.926.6 1.477v3.81a2.1 2.1 0 0 1-.6 1.476 2.05 2.05 0 0 1-1.466.619H4.733c-.552 0-1.08-.224-1.466-.619a2.1 2.1 0 0 1-.6-1.476v-3.81c0-.551.214-1.083.6-1.477M4 7.476v2.429c0 .206.08.401.22.543a.72.72 0 0 0 .513.219h6.534a.72.72 0 0 0 .514-.219.78.78 0 0 0 .219-.543V7.476zm8-1.333H4v-.048c0-.206.08-.402.22-.543a.72.72 0 0 1 .513-.219h6.534a.72.72 0 0 1 .514.219c.139.141.219.337.219.543zm-7.233 3c0-.368.298-.667.666-.667H7.65a.667.667 0 0 1 0 1.333H5.433a.667.667 0 0 1-.666-.666M1 10.133c.368 0 .667.299.667.667v2.222H4a.667.667 0 0 1 0 1.333H1.556a1.22 1.22 0 0 1-1.223-1.222V10.8c0-.368.299-.667.667-.667M1 5.555a.667.667 0 0 0 .667-.666V2.667H4a.667.667 0 0 0 0-1.334H1.556A1.22 1.22 0 0 0 .333 2.555V4.89c0 .368.299.666.667.666M15 10.133a.667.667 0 0 0-.667.667v2.222H12a.667.667 0 0 0 0 1.333h2.444a1.22 1.22 0 0 0 1.223-1.222V10.8a.667.667 0 0 0-.667-.667M15 5.555a.667.667 0 0 1-.667-.666V2.667H12a.667.667 0 0 1 0-1.334h2.444a1.22 1.22 0 0 1 1.223 1.222V4.89a.667.667 0 0 1-.667.666" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })